/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Apps from './Apps/index'
import MarketingAnalytics from './MarketingAnalytics/index'
import NewCalendar from './NewCalendar/index'
import NewPayments from './NewPayments/index'
import NewProfile from './NewProfile/index'
import NewReporting from './NewReporting/index'
import NewTxPlanning from './NewTxPlanning/index'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/FeatureFlags/Content",
  value
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 marginTop={dtSpaceS}
 text="Greyfinch Labs"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 size="large"
 text="These feature flags turn on certain functionality in the PMS, for selected locations or PCs."
/>
<NewProfile
  viewPath={`${viewPath}/NewProfile`}
/>
<NewReporting
  viewPath={`${viewPath}/NewReporting`}
/>
<Apps
  viewPath={`${viewPath}/Apps`}
/>
<NewPayments
  viewPath={`${viewPath}/NewPayments`}
/>
<MarketingAnalytics
  viewPath={`${viewPath}/MarketingAnalytics`}
/>
<NewCalendar
  viewPath={`${viewPath}/NewCalendar`}
/>
<NewTxPlanning
  viewPath={`${viewPath}/NewTxPlanning`}
/>
</div>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={value}
/>
</div>
{children}
</React.Fragment>)
}